module.exports = __webpack_public_path__ + "img/B3.fce2b9a5.png";